export const segmentProps = {
  shopName: "shop name",
  orderId: "order id",
  cartId: "cart id",
  orderServices: "order services",
  shopAddress: "shop address",
  vehicleId: "vehicle id",
  vin: "vin",
  vehicleName: "vehicle name",
  vehicleYear: "vehicle year",
  vehicleMake: "vehicle make",
  vehicleModel: "vehicle model",
  vehicleSubModel: "vehicle sub model",
  licensePlateNumber: "license plate number",
  licensePlateState: "license plate state",
  shopId: "shop id",
  walkIn: "walk in",
  bookingAppointmentDate: "booking appointment date and time",
  bookingAppointmentTime: "booking appointment time",
  firstNameWithSpace: "first name",
  lastNameWithSpace: "last name",
  email: "email",
  zip: "zip",
  phone: "phone",
  firstName: "firstName",
  lastName: "lastName",
  totalCostOfOwnership: "total cost of ownership",
  lifetimeSavings: "lifetime savings",
  ytdCostOfOwnership: "ytd cost of ownership",
  ytdSavings: "ytd savings",
  numberOfServices: "number of services",
  promoCode: "promo code",
  dateOfCompletion: "date of completion",
  miles: "miles",
  serviceName: "service name",
  cost: "cost",
  vehicleEngine: "vehicle engine",
  estimatedCurrentMileage: "estimated current mileage",
  lastRecordedMileage: "last recorded mileage",
  estimatedMilesPerMonth: "estimated miles per month",
  lastMaintenanceDate: "last maintenance date",
  nextMaintenanceDate: "next maintenance date",
  methodToAddVehicle: "method to add vehicle",
  vehicleImage: "vehicle image",
  signInMethod: "signin method",
  userType: "user type",
  affiliation: "affiliation",
  appleOrAndroid: "apple or android",
  source: "from where",
  beforeOrAfterSignup: "before or after sign up",
  paymentMode: "payment mode",
  searchTerm: "search term",
  bookingAppointmentDay: "booking appointment day",
  yourTotal: "booking total",
  buttonName: "button name",
  existingShopAddress: "existing shop address",
  existingShopCity: "existing shop city",
  existingDate: "existing booking appointment date",
  existingTime: "existing booking appointment time",
  bookingCreatedDate: "booking created date and time",
  bookingCreatedTime: "booking created time",
  servicesName: "services name",
  planType: "plan type",
  milesPerMonth: "miles per month",
  reminderTime: "reminder time",
  action: "action",
  shopCity: "shop city",
  upcomingMiles: "upcoming miles",
  numberOfOrderServices: "number of order services",
  device: "device",
  itemName: "option",
  currentlyDueServices: "currently due services",
  pastDueServices: "past due services",
  upcomingServices: "upcoming services",
  isDefault: "is default",
  carsAdded: "cars added",
  numberOfServicesBooked: "number of services booked",
  name: "name",
  duringOnboarding: "during onboarding",
  screenNumber: "screen number",
  previousPlan: "previous plan",
  selectedPlan: "selected plan",
  didUserSignedFromNoVehicle: "did user logged in from no vehicle",
  walletType: "wallet type",
  approvedServices: "approved services",
  declinedServices: "declined services",
  serviceId: "service id",
  servicePrice: "service price",
  currency: "currency",
  revenue: "revenue",
  shopPhoneNumber: "shop phone number",
  eventSourceName: "event_source_name",
  deductible: "deductible",
  total: "total",
  registrationFee: "registration fee",
  mapVersion: "map_version",
  milesToUnlock: "miles to unlock",
  earnedMiles: "earned miles",
  rewardsName: "rewards name",
  milesApplied: "miles applied",
  tireBrand: "tire brand",
  tireDetails: "tire details",
  tireImage: "tire image",
  tirePrice: "price",
  tireRetailPrice: "tire retail price",
  tireQuantity: "tire quantity",
  tireTotal: "total",
  tireRatings: "tire ratings",
  tireOptions: "tire options",
  selectedTireFilters: "tire filters",
  deeplink: "deep link",
  factoryTireSize: "factory tire size",
  availableTiresCount: "available tires",
  tireSelectedFilters: "tire applied filters"
}
